export default class DissociateWorkTypeWithEntityError extends Error {

}
